// extracted by mini-css-extract-plugin
module.exports = {"btn":"DisableProvider_btn__ZArPW"};